// F3/#5: shows a category's objective and scope ("qué incluye") to the
// collaborator in the public LMS. Renders nothing when the admin has not filled
// these descriptive fields, so it never leaves an empty box.

type Props = {
  objective?: string | null;
  includes?: string | null;
};

export function CategoryScope({ objective, includes }: Props) {
  if (!objective && !includes) return null;

  return (
    <div className="mt-3 space-y-1 rounded-lg border border-border bg-muted/30 p-3 text-xs text-muted-foreground">
      {objective && (
        <p>
          <span className="font-medium text-foreground">Objetivo:</span> {objective}
        </p>
      )}
      {includes && (
        <p>
          <span className="font-medium text-foreground">Incluye:</span> {includes}
        </p>
      )}
    </div>
  );
}
